export default __webpack_public_path__ + "static/media/login_logo.4be7efaa.png";